<style scoped>
    .back-drop{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(120,120,120,.2);
        z-index: 999;
    }
    .loading-icon{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
    }
</style>
<template>
    <div class="back-drop text-center" v-show="isShowing">
        <div class="loading-icon">
            <Spin size="large"></Spin>
        </div>
    </div>
</template>
<script>
    import Util from '../../libs/util';
    export default {
        props: ['vShow'],
        data () {
            return {
                //
            }
        },
        computed: {
            isShowing(){
                return this.vShow;
            }
        },
        created(){
            //
        },
        methods: {
            //
        }
    }
</script>
